module.exports = __webpack_public_path__ + "media/images/press_kit/shoretime_bg/email/banner-900b3d9d2be1080101759d3bc767a102.jpg";